import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { Input } from '@bucketplace/commerce-admin-ui';

import { useFieldForm } from '../../../hooks';
import { FieldItem } from '../../FieldItem';

export const RGB = {
  r: 'r',
  g: 'g',
  b: 'b',
} as const;

type RGBType = keyof typeof RGB;

const RGB_LENGTH = 3;
const INPUT_LABELS = [
  RGB.r,
  RGB.g,
  RGB.b,
];

export function RgbInput({
  color,
  onChange,
}: {
  color: Record<RGBType, number>,
  onChange: (value: string) => void,
}) {
  const {
    fields,
    register,
    onChange: onInputChange,
  } = useFieldForm();

  const handleChangeInput = (rgbType: RGBType, value: string) => {
    onInputChange(rgbType, Math.min(+value, 255));
  };

  const handleBlurInput = () => {
    const hexR = decimalToFormmatedHex(fields.r);
    const hexG = decimalToFormmatedHex(fields.g);
    const hexB = decimalToFormmatedHex(fields.b);

    onChange(`#${hexR}${hexG}${hexB}`);
  };

  useEffect(() => {
    INPUT_LABELS.forEach((label) => {
      register(label, {
        defaultValue: color[label],
      });
    });
  }, []);

  useEffect(() => {
    INPUT_LABELS.forEach((label) => {
      onInputChange(label, color[label]);
    });
  }, [color.r, color.g, color.b]);

  return (
    <InputRow>
      {
        INPUT_LABELS.map((label) => (
          <FieldItem
            key={`color_input_${label}`}
            label={label.toUpperCase()}
            direction="HORIZONTAL"
          >
            <Input
              aria-label={`color input ${label}`}
              size={32}
              value={fields?.[label]}
              maxLength={RGB_LENGTH}
              onChange={(event) => {
                handleChangeInput(label, event.target.value.replace(/[^0-9]/i, ''));
              }}
              onBlur={handleBlurInput}
            />
          </FieldItem>
        ))
      }
    </InputRow>
  );
}

export function decimalToFormmatedHex(decimal: number) {
  return decimal.toString(16).padStart(2, '0');
}

const InputRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px;
  gap: 7px;
  box-sizing: border-box;
  
  span {
    margin-right: 4px;
  }

  input {
    padding-right: 0;
  }
`;
